import { atom } from 'jotai';

import { FloorSettings, UserSettings } from '@data';

const DEFAULT_USER_SETTINGS: UserSettings = {
    userId: '',
    dateOfBirth: null,
    sex: null,
    handicap: 54,
    locale: 'en',
    userPreferredUnit: 'metric',
    showCorridors: false,
    showGoal: true,
    leftHanded: false,
    liveView: false,
    comparisonSwingId: null,
    showComparison: false,
};
// The active user can be the student or the coach.
export const activeUserSettingsAtom = atom<UserSettings>(DEFAULT_USER_SETTINGS);
// The user currently logged in.
export const userSettingsAtom = atom<UserSettings>(DEFAULT_USER_SETTINGS);

// we want to store locale separately, and not derive from user settings,
// because we switch user settings per scope, but we respect locale settings for the user
export const userLocaleAtom = atom<'en' | 'is'>();

export const floorSettingsAtom = atom<FloorSettings>();
